export type OrderNotificationKind = 'order' | 'service_request';

export interface OrderNotificationItem {
  readonly id: string;
  readonly kind: OrderNotificationKind;
  readonly entityId: number | string;
  readonly number: number;
  readonly receivedAt: string;
  readonly customerName?: string;
}

/** @deprecated Prefer entityId; kept for callers that still read orderId. */
export type OrderNotificationItemLegacy = OrderNotificationItem & {
  readonly orderId?: number | string;
};

/** Hora corta (HH:mm) para el listado de la campanita, igual formato que el resto del panel. */
export function formatOrderNotificationTime(receivedAt: string): string {
  const date = new Date(receivedAt);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
}
